import React, { useRef, useState, useEffect } from 'react';
import {IProps, IState} from './types';
import * as S from './styles';
import { AddIcon } from '@assets/icons/addIcon';
import DeleteIcon from '@assets/icons/deleteIcon';
import  FolderEdit from '../FolderEdit';
import  FolderDelete from '../FolderDelete';
import  DropFolder from '../DropFolder';

const Folders:React.FC<IProps> = (props, state: IState) => {
  const [addFolder, setAddFolder] = useState(false);
  const [editFolder, setEditFolder] = useState(-1);
  const [deleteFolder, setDeleteFolder] = useState(-1);
  const [openDelete, setOpenDelete] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  let clickFolders = 0;

  useEffect(() => {
    if (openDelete && props.finishDeleteFolder)setOpenDelete(false);
  }, [props.finishDeleteFolder])

  const handleAddEditFolder = (edit:boolean, hide:boolean) => {
    if (!edit){
      setAddFolder(hide);
      setTimeout(function() {
        if(ref && ref.current)ref.current.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest'});
      }, 500);
    }
    else setEditFolder(-1);
    clickFolders= 0;
  }

  const handleDeleteFolder = (idx: number) => {
    setDeleteFolder(idx);
    setOpenDelete(true);
  }

  const handleDeleteFolderAfter = (action:string) =>{
    if (props.onActions) props.onActions( null, action , deleteFolder);
  }

  const handleClicks = (index:number) => {
    clickFolders++;
    setTimeout(() => {
      if (clickFolders===1) props.selectFolder(index);
      if (clickFolders===3 && index>1) setEditFolder(index);
      clickFolders=0;
    }, 700)
  }

  const handleDrop= (index:number, item:any) => {
    if (props.onActions) props.onActions( item.item, 'DROPDESIGNS', index);
  }

  return ( 
    <S.Root>
      <S.BoxContainer>
        <S.Title>
          FOLDERS
        </S.Title>
        <S.FoldersContainer>
          {
            props.folders?.length > 0 &&
            props.folders.map((folder: {id: null|string, name: string, counter: number}, index: number) => {
              if (editFolder===index) return <FolderEdit key={index} 
                                             edit={true} 
                                             value={folder.name}
                                             onAction={(value)=>handleAddEditFolder(true, value)}/>;
              else {
                return (
                  <DropFolder key={`drop${index}`} selectedFolder={props.selectedFolder===folder.name} onDrop={handleDrop} index={index} disabled={index<2 ? true : false }>
                    <S.FolderContainer 
                      key={index} 
                      onDoubleClick={() => handleClicks(index)}
                    >
                      <S.FolderTitle onClick={() => handleClicks(index)}>
                        {folder.name}
                      </S.FolderTitle>
                      <S.ContainerInfo>
                        {index>1 &&
                        <S.FolderDelete onClick={() => handleDeleteFolder(index)}>
                          <DeleteIcon style={{ marginRight:'11px', fillColor:'#204078', fillOpacity:'.5', width:'15', height:'19'}}/>
                        </S.FolderDelete>}
                        <S.FolderNumber onClick={() => handleClicks(index)}>
                          {`(${folder.counter})`}
                        </S.FolderNumber>
                      </S.ContainerInfo>
                    </S.FolderContainer>
                  </DropFolder>
                )
              }
            })
          }
          <div ref={ref}/>
        </S.FoldersContainer>
        {addFolder && <FolderEdit edit={false} value='' onAction={(value)=>handleAddEditFolder(false, value)}/>}
        <S.newFolderContainer
          onClick={()=>setAddFolder(true)}
        >
          <S.newFolderIconContainer>
            <AddIcon
              style={{fillColor: 'rgba(16, 16, 89, 0.6)'}}
            />
          </S.newFolderIconContainer>
          <S.newFolderTitle>
            New Folder
          </S.newFolderTitle>
        </S.newFolderContainer>
      </S.BoxContainer>
      {
        openDelete &&
        <FolderDelete
          open = {openDelete}
          setOpen = {setOpenDelete}
          onActions={handleDeleteFolderAfter}
        />
      }
    </S.Root>
  );
}

export default Folders;